import React from 'react'
import CDPRequestForm from '../views/CDPRequestForm'
import '../../assets/css/base.css'
import '../../assets/css/App.css'
import '../../assets/css/cdp.css'
import '../../assets/css/print.css'
import '../../assets/css/smp_cdp.css'
import '../../assets/css/smp_base.css'

const FormContainer = () => {
    return (
        <div>
            <div className="wrapFrame">
                <CDPRequestForm></CDPRequestForm>
            </div>
        </div>
    )
}

export default FormContainer
